<template>
    <div>
        <a class="a-style" @click="linkDownload('https://tools.yufuid.com/')">玉符tools</a>
    </div>
</template>

<script>
    export default {
        methods:{
            linkDownload (url) {
                window.open(url,'_blank') // 新窗口打开外链接
            }
        }
    }
</script>

<style scoped>
    .a-style {
        color: #0500ee;
        cursor: pointer;
        text-decoration: underline;
    }
</style>